import { UnfoldMore } from '@mui/icons-material';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { OrgTypeWithRole } from 'src/@types/org';
import { states } from 'src/assets/data/states';
import { CustomAvatar } from 'src/components/custom-avatar';
import { formatOrgSubheader } from 'src/utils/formatOrgSubheader';

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2.5),
  border: `1px solid ${alpha(theme.palette.common.black, 0.12)}`,
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  background: `linear-gradient(180deg, ${alpha(theme.palette.background.default, 0)}, ${theme.palette.background.neutral})`,
  boxShadow: `0px 1px 2px 0px ${alpha(theme.palette.grey[500], 0.16)}`,
  cursor: 'pointer',
  '&:hover': {
    background: theme.palette.background.neutral,
    border: `1px solid ${alpha(theme.palette.common.black, 0.12)}`,
  },
}));

type NavOrgProfileButtonProps = {
  currentOrg: OrgTypeWithRole | null;
  onClick: () => void;
};

export default function NavOrgProfileButton({ currentOrg, onClick }: NavOrgProfileButtonProps) {
  return (
    <StyledRoot onClick={onClick}>
      <Stack direction="row">
        <CustomAvatar src={currentOrg?.signed_url} alt={currentOrg?.name} name={currentOrg?.name} />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap maxWidth={120}>
            {currentOrg?.name}
          </Typography>

          <Tooltip
            placement="bottom-start"
            title={
              currentOrg?.race_typeRace === 'national' ? (
                'All 50 States'
              ) : currentOrg?.race_typeRace === 'national-multi-state' &&
                currentOrg.selected_state_list ? (
                <ul style={{ listStyleType: 'none' }}>
                  {currentOrg.selected_state_list.map((state) => (
                    <li key={state}>{states[state]}</li>
                  ))}
                </ul>
              ) : (
                ''
              )
            }
          >
            <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }} maxWidth={120}>
              {currentOrg ? formatOrgSubheader(currentOrg) : ''}
            </Typography>
          </Tooltip>
        </Box>
      </Stack>
      <IconButton size="small">
        <UnfoldMore fontSize="small" />
      </IconButton>
    </StyledRoot>
  );
}
